import React, { useEffect, useState } from 'react';
import PageContainer from '../../../components/PageContainer';
import { useParams, useLocation } from 'react-router-dom';
import { getWorkflowHistoryAndTasksByWorkflowId } from '../../../redux/api/workflows';
import { getAllCaseDetails, getCaseUpdateHistoryByCaseId } from '../../../redux/api/cases';
import { useSnackbar } from 'notistack';
import { Grid, Typography } from '@mui/material';
import { Autorenew } from '@mui/icons-material';
import CaseDetails from '../../../components/CaseDetails';

const CaseDetailsPage = () => {
    const { case_id } = useParams();
    const { search } = useLocation();
    const { enqueueSnackbar } = useSnackbar();
    const searchParams = new URLSearchParams(search);
    const searchTab = searchParams.get('tab');
    const [tab, setTab] = useState(0);
    const [processing, setProcessing] = useState(false);
    const [caseDetails, setCaseDetails] = useState({});
    const [selectionModel, setSelectionModel] = useState([]);

    const init = async (caseId) => {
        try {
            setProcessing(true);
            const res = await getAllCaseDetails(caseId);
            let conversations = {};
            if (res?.resultObject?.workflow?.workflowId) {
                conversations = await getWorkflowHistoryAndTasksByWorkflowId(res?.resultObject?.workflow?.workflowId);
            }

            const caseHistory = await getCaseUpdateHistoryByCaseId(caseId);

            setCaseDetails({
                ...res?.resultObject,
                // caseWithReportedFIs: caseData?.caseWithReportedFIs || null,
                chats: conversations?.resultObject?.chatCommunications || [],
                publicMailConversation: conversations?.resultObject?.publicMailConversation?.emailResponseVM?.value || [],
                internalMailConversation: conversations?.resultObject?.internalMailConversation?.emailResponseVM?.value || [],
                caseHistory: caseHistory?.resultObject || [],
            });
            setSelectionModel([caseId]);
        } catch (err) {
            enqueueSnackbar(err?.message || 'An error occurred', {
                variant: 'error',
            });
        } finally {
            setProcessing(false);
        }
    };

    const getTabValue = (tab) => {
        let index = 0;
        if (tab == 'details') index = 0;
        if (tab == 'conversation') index = 1;
        if (tab == 'mails') index = 2;
        if (tab == 'history') index = 3;
        setTab(index);
    };

    useEffect(() => {
        init(case_id);
    }, [case_id]);

    useEffect(() => {
        getTabValue(searchTab);
    }, [searchTab]);

    return (
        <PageContainer showTitle={false} processing={processing} pageTitle="Case Details">
            {processing ? (
                <Grid container justifyContent={'center'} alignItems={'center'} flexDirection={'column'}>
                    <Autorenew fontSize="large" className="rotating" />
                    <Typography textAlign={'center'}>Loading...</Typography>
                </Grid>
            ) : (
                <>
                    <CaseDetails init={init} caseDetails={caseDetails} defaultTab={tab} selectionModel={selectionModel} setSelectionModel={() => {}} />
                </>
            )}
        </PageContainer>
    );
};

export default CaseDetailsPage;
